import React, { Fragment, memo, useCallback, useContext, useEffect, useState } from "react";
// import { Field, Form as FinalForm, useForm } from "react-final-form";
//import arrayMutators from "final-form-arrays";
import _css from "./TransferHoursForm.module.scss";
import {
    Alert,
    AlertActionCloseButton,
    Button,
    Grid,
    GridItem,
    Skeleton,
    Spinner,
    Text,
    Form,
    Title
} from "@patternfly/react-core";
import { CheckIcon, PlusIcon } from '@patternfly/react-icons';
import variants from "../../../sass/colors.module.scss";
import { InputErrors } from "components";
import useRequestFetch from "react-requests-fetch";
import { FETCH_TRANSACTION_QUALITIES } from "services/urls";
import { decodeJwtToken } from "modules/security";
import { useMutation, useQueryClient } from "react-query";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { TransferHours } from "api"
import { SessionsContext } from "contexts";
import { API_PUT_DESCRIPTION_TRANSACTION } from "api/transactions";
import { Service } from "./service";

type Message = {
    variant: "success" | "danger" | "default" | "warning" | "info" | undefined
    message: string
} | undefined

interface Props {
    toWhom: any
    _fromWhom: any
    _updateHours: any
    callback: any
    idTransaction?: any
}

type TransferHoursType = {
    hour: number,
    description: string,
    receiver_id: string,
    quality: Array<{ id: string; name: string }>
}

const TransferHoursForm: React.FC<Props> = (
    {
        toWhom,
        _fromWhom,
        _updateHours,
        callback,
        idTransaction
    }
) => {
    const accessToken = localStorage.getItem("x-access-token");
    const { sess } = useContext(SessionsContext);
    const [fetching, setFetching] = useState<boolean>(true);
    const [message, setMessage] = useState<Message>();
    const [chips, setChips] = useState<any>([]);
    const [blocked, isBlocked] = useState<boolean>(false);
    

    const queryClient = useQueryClient()
    const { control, handleSubmit, setValue, getValues/*, formState: { isValid, }*/ } = useForm<TransferHoursType>({
        mode: "onChange",
        defaultValues: {
            receiver_id: toWhom?.public_id,
            quality: []
        }
    })
    const { mutateAsync } = useMutation({
        mutationFn: TransferHours,
        mutationKey: ["TRANSFER_HOURS"],
        onSuccess: async () => {
            await queryClient.invalidateQueries(["SEARCH_CURRENT_USER"])
        }
    })
    //const requestUpdate = useMutation(API_PUT_DESCRIPTION_TRANSACTION);

    const [reqUserQualities] = useRequestFetch({
        uri: FETCH_TRANSACTION_QUALITIES,
        headers: { "accepts": "application/json" }
    });

/*     const resetForm = (form) => {
        // @ts-ignore
        Array.from(form.elements).forEach((input) => input.value = '');
    }
 */
    const submit: SubmitHandler<TransferHoursType> = async (values) => {
        if(values.quality.length === 0 || values.quality.length > 3) {
            setMessage({
                variant: "danger",
                message: "Veuillez sélectionner entre 1 et 3 qualités."
            });
            return;
        }
        await mutateAsync({
            "description": values.description ? values.description : "",
            "receiver_id": values.receiver_id,
            "hours": values.hour,
            "quality": values.quality
        })

        callback()
    }

/*     const deleteItem = (value) => {
        const updatedChips = chips.filter(chip => chip.id !== value.id);
        setChips(updatedChips);
        setValue("quality", updatedChips.map(chip => ({ id: chip.id, name: chip.name })));
    }; */

    const [selectedQualities, setSelectedQualities] = useState<Array<{ id: string; name: string }>>([]);

    const [isAdmin, setIsAdmin] = useState<boolean>(false);

    useEffect(() => {
        if(sess) {
            const decoded = decodeJwtToken(sess);
            if((decoded?.roles?.some(role => role.id === 1) || (localStorage.getItem("x-imperso")))) { // Assuming role id 1 is admin
                setIsAdmin(true);
            } else {
                setIsAdmin(false);
            }
        } else {
            setIsAdmin(false);
        }
    }, [sess]);

    useEffect(() => {
        (reqUserQualities && reqUserQualities.statusCode === 200) &&
            setFetching(false)
    }, [reqUserQualities])

    useEffect(() => {
        setValue("quality", selectedQualities);
    }, [selectedQualities, setValue]);

    // useEffect(() => {
    //     setValue("quality", chips.map(chip => chip.name));
    // }, [chips, setValue]);


    useEffect(() => {
        // Mise à jour des valeurs en gardant l'ID et le nom
        setValue("quality", chips.map(chip => ({ id: chip.id, name: chip.name })));
    }, [chips, setValue]);

    useEffect(() => {
        if(toWhom && accessToken) {
            if(String(toWhom.public_id) === String(decodeJwtToken(accessToken)["public_id"])) {
                setMessage({
                    variant: "danger",
                    message: "Vous ne pouvez pas transférer du temps à vous-même, sélectionnez un utilisateur dans le système qui n'est pas vous et continuez."
                })
                isBlocked(true)
            } else isBlocked(false)
        }
        // eslint-disable-next-line
    }, [toWhom])

     const serviceCallback = useCallback((value) => {
        const current = getValues("description") || ""
        //console.log("service callback", value, current);
        const result = `${value ? `@${value?.title}:` : ""} - ${value?.user_display_name}\r\n ${current}`;
        setValue("description", result)
    }, []) 

    return (
        <Fragment>
            {(blocked && message) && <Alert isInline title={message.message} variant={message.variant} />}
            <Form
                onSubmit={handleSubmit(submit)}
            >
                <Grid hasGutter>
                    <GridItem>
                        <GridItem lg={10} sm={12}>
                            <Text>
                                Vous êtes sur le point de transférer des heures
                                à <b>{toWhom && toWhom["first_name"] + ' ' + toWhom["last_name"]}</b> si
                                vous êtes certain
                                de cette opération, veuillez indiquer le nombre d'heures que vous souhaitez
                                envoyer.
                                Notez que vous ne pouvez pas envoyer plus que le nombre d'heures dont vous
                                disposez dans votre compte.
                            </Text>
                        </GridItem>
                    </GridItem>

                    <GridItem lg={12}>
                        <Controller
                            name="hour"
                            rules={{ required: true }}

                            control={control}
                            render={({ field: { onChange, onBlur, name, value }, fieldState: { error } }) => (
                                <label htmlFor="hours">
                                    <span className={_css.labels}>Nombre d'heures</span>
                                    <input
                                        className={[
                                            _css.input,
                                            error && variants.error_input
                                        ].join(" ")}
                                        type="number"
                                        id="hours"
                                        onBlur={onBlur}
                                        onChange={onChange}
                                        name={name}
                                        placeholder={"Nombre d'heures"}
                                        value={value}
                                    />
                                    {error && <InputErrors message={error?.message as any} />}
                                </label>
                            )}

                        />
                    </GridItem>

                                       <GridItem>
                        <span className={_css.labels}>Service</span>
                        <Service callback={serviceCallback} public_id={toWhom?.public_id} />
                    </GridItem>
{/*                     {!isAdmin &&
                        <input type="hidden" value="_" id="description" name="description" />
                    }
                    {isAdmin &&
 */}                     <>
                     <input type="hidden" value={idTransaction} id="id" name="id" />
                     <GridItem lg={12}>
                            <Controller
                                name="description"
                                rules={{ required: true }}

                                control={control}
                                render={({ field: { onChange, onBlur, name, value }, fieldState: { error } }) => (
                                    <label htmlFor="description">
                                        <span className={_css.labels}>Brève description du service</span>
                                        <textarea
                                            className={[
                                                _css.input,
                                                error && variants.error_input
                                            ].join(" ")}
                                            id="description"
                                            onBlur={onBlur}
                                            onChange={onChange}
                                            name={name}
                                            style={{ minHeight: 250 }}
                                            placeholder={"Brève description du service"}
                                            value={value} />
                                        {error && <InputErrors message={error!.message as any} />}
                                    </label>
                                )} />
                        </GridItem></> 
 {/*                    }
 */}
                    <GridItem lg={12}>
                        <Title headingLevel="h4">Qualités</Title>
                        <Text>Choisissez les qualités que vous souhaitez attribuer à l’utilisateur.</Text>
                        {fetching && <Skeleton height="50px" screenreaderText="Loading contents" />}
                        {!fetching && (
                            <div className={_css.qualityChipContainer}>
                                <div className={_css.selectionHeader}>
                                    <Text className={_css.counter}>
                                        {selectedQualities.length} / 3 qualités sélectionnées
                                    </Text>
                                </div>
                                {reqUserQualities?.payload?.map((currentChip) => {
                                    const isSelected = selectedQualities.some(q => q.id === currentChip.id);

                                    return (
                                        <button
                                            key={currentChip.id}
                                            type="button"
                                            onClick={() => {
                                                setSelectedQualities(prevSelectedQualities => {
                                                    if (isSelected) {
                                                        return prevSelectedQualities.filter(q => q.id !== currentChip.id);
                                                    } else {
                                                        if (prevSelectedQualities.length < 3) {
                                                            return [...prevSelectedQualities, { id: currentChip.id, name: currentChip.name }];
                                                        } else {
                                                            setMessage({
                                                                variant: "warning",
                                                                message: "Vous ne pouvez sélectionner que 3 qualités maximum."
                                                            });
                                                            return prevSelectedQualities;
                                                        }
                                                    }
                                                });
                                            }}
                                            className={`${_css.chipLikeButton} ${isSelected ? _css.selected : ""}`}
                                        >
                                            <span className={_css.icon}> {isSelected ? <CheckIcon /> : <PlusIcon />}</span>
                                            {currentChip.name}
                                        </button>
                                    );
                                })}
                            </div>
                        )}
                    </GridItem>

                    {(!fetching && message) &&
                        <GridItem>
                            <Alert isInline variant={message.variant || "default"}
                                title={"Transfert d'heures"}
                                actionClose={<AlertActionCloseButton
                                    onClose={() => setMessage(undefined)} />}>
                                <Text>
                                    {message.message}
                                </Text>
                            </Alert>
                        </GridItem>}
                    <GridItem>
                        <Button isDisabled={fetching} type={"submit"}>
                            {fetching ? <Spinner size="sm" /> : <span>Transférer</span>}
                        </Button>
                    </GridItem>
                </Grid>
            </Form>
        </Fragment>
    )
}

export default memo(TransferHoursForm);
